import React, { useEffect } from "react";
import { useFormContext } from "../context/FormContext";
import { FF2EventName, trackFF2Event } from "../analytics";

export const MagicLinkSent: React.FC = () => {
  const { formData } = useFormContext();

  useEffect(() => {
    trackFF2Event(FF2EventName.MAGIC_LINK_SENT, formData);
  }, []);

  return (
    <div className="heroff2-form">
      <h2>Magic link sent!</h2>
      <h3>
        We can see you already have an account with us. Please check your email inbox for a magic link to log in.
      </h3>
    </div>
  );
};
